import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

import { Dates } from 'context/DateProvider/DateProvider';

export const getFormattedTime = (dateTimeRange: Dates, formatString: string, timeZone: string) => {
  const zonedFrom = utcToZonedTime(new Date(dateTimeRange.from), timeZone);
  const zonedTo = utcToZonedTime(new Date(dateTimeRange.to), timeZone);

  const formattedFrom = format(zonedFrom, formatString);
  const formattedTo = format(zonedTo, formatString);
  return `${formattedFrom} - ${formattedTo}`;
};
